import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

const tabCount = 3;

const LeaderBoardTabsFilterSkeleton = () => (
  <Box
    display="flex"
    gap={2}
    bgcolor="#23242a"
    mt={3}
    p={1}
    borderRadius={'12px'}
    width="100%"
    maxWidth={600}
    mx="auto">
    {[...Array(tabCount)].map((_, idx) => (
      <Skeleton
        key={idx}
        variant="rectangular"
        width={180}
        height={32}
        animation="wave"
        sx={{
          borderRadius: 3,
          bgcolor: '#18191d',
          opacity: 1,
        }}
      />
    ))}
  </Box>
);

export default LeaderBoardTabsFilterSkeleton;
